import type { ListChildComponentProps } from "react-window";

export const getVirtualizedProps = <T>({ data, index }: ListChildComponentProps<T[]>): T => {
  return data[index];
};
